export default "<app-add-new-users></app-add-new-users>\r\n"